class TooltipItem extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector(".tooltip-item__content");

    this.onPointerEnterListener = this.onPointerEnter.bind(this);
    this.onPointerLeaveListener = this.onPointerLeave.bind(this);

    this.handleTouchListener = this.handleTouch.bind(this);

    this.handleModalPositionListener = this.handleModalPosition.bind(this);

    this.removeClassListener = this.removeClass.bind(this);

    this.onAreaClickListener = this.onAreaClick.bind(this);
  }

  connectedCallback() {
    // MFS-5474 (QA #13): по ТЗ клубный тултип открывается нажатием, а не
    // наведением. Остальные тултипы темы (ваза, открытка, сводка заказа)
    // ведут себя как раньше, поэтому поведение включается атрибутом, а не
    // меняется в компоненте целиком.
    if (this.dataset.trigger !== "click") {
      this.addEventListener("pointerenter", this.onPointerEnterListener);
      this.addEventListener("pointerleave", this.onPointerLeaveListener);
    }

    this.addEventListener("click", this.handleTouchListener);

    this.area = this.closest("[data-tooltip-area]");
    if (this.area) this.area.addEventListener("click", this.onAreaClickListener);

    window.addEventListener("resize", this.handleModalPositionListener);
  }

  disconnectedCallback() {
    this.removeEventListener("pointerenter", this.onPointerEnterListener);
    this.removeEventListener("pointerleave", this.onPointerLeaveListener); 
    if (this.area) this.area.removeEventListener("click", this.onAreaClickListener);
  }

  onAreaClick(event) {
    // ссылки и кнопки внутри плашки работают как раньше
    if (event.target.closest("a, button, input, select, textarea, label")) return;
    this.handleTouch(event);
  }

  onPointerEnter(event) {
    if (event.pointerType != "touch") {
      this.modal.classList.add("active");
      this.handleModalPosition();
    }
  }

  onPointerLeave(event) {
    if (event.pointerType != "touch") this.modal.classList.remove("active");
  }

  handleTouch(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.modal.classList.contains("active")) {
      document.querySelectorAll("tooltip-item .tooltip-item__content.active").forEach((el) => {
        if (el !== this.modal) el.classList.remove("active");
      });
    }
    this.modal.classList.toggle("active");
    this.handleModalPosition();
    setTimeout(() => document.addEventListener("click", this.removeClassListener), 0);
  }

  removeClass() {
    this.modal.classList.remove("active");
    document.removeEventListener("click", this.removeClassListener);
  }

  handleModalPosition() {
    if (!this.classList.contains("info-tooltip")) {
      this.modal.style.removeProperty('right');
      const modalRect = this.modal.getBoundingClientRect();
      const tooltipOffset = getComputedStyle(this).position == "absolute" ? "0px" : "-10px";
      if (window.innerWidth - modalRect.right < 10) this.modal.style.right = tooltipOffset;
      return;
    }

    this.modal.style.marginLeft = "";
    if (!this.modal.classList.contains("active")) return;
    const rect = this.modal.getBoundingClientRect();
    const vw = document.documentElement.clientWidth;
    const gap = 8;
    let shift = 0;
    if (rect.right > vw - gap) shift = vw - gap - rect.right;
    if (rect.left + shift < gap) shift = gap - rect.left;
    if (shift) this.modal.style.marginLeft = `${shift}px`;
  }
}

if (!customElements.get("tooltip-item")) {
  customElements.define("tooltip-item", TooltipItem)
}
